// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__28V38","list":"BalanceDue_list__18lF5","listRow":"BalanceDue_listRow__idl-y","total":"BalanceDue_total__3ous3"};